'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('glossaryTermModule')

.factory('glossaryTermService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/GlossaryTerm';

    var service = {};

    // Glossary Term
    service.getGlossaryTerm = function (glossaryTermId) {
        return $http
            .get(baseUrl + '/' + glossaryTermId)
            .then(function (response) { return response.data; });
    };

    service.createOrUpdateGlossaryTerm = function (glossaryTerm) {
        var reqUrl = baseUrl;
        if (!_.isUndefined(glossaryTerm.GlossaryTermID)) reqUrl += '/' + glossaryTerm.GlossaryTermID;

        return $http
            .post(reqUrl, { GlossaryTerm: glossaryTerm })
            .then(function (response) { return response.data; });
    };

    service.deleteGlossaryTerm = function (glossaryTerm) {
        var reqUrl = baseUrl;
        if (!_.isUndefined(glossaryTerm.GlossaryTermID)) reqUrl += '/' + glossaryTerm.GlossaryTermID + '/Delete';

        return $http
            .delete(reqUrl)
            .then(function (response) { return response.data; });
    };



    return service;
}]);
